export enum adminNewsNewTypes {
    FETCH_ADMIN_NEWS_NEW_REQUEST = "FETCH_ADMIN_NEWS_NEW_REQUEST",
    FETCH_ADMIN_NEWS_NEW_SUCCESS = "FETCH_ADMIN_NEWS_NEW_SUCCESS",
    FETCH_ADMIN_NEWS_NEW_FAILURE = "FETCH_ADMIN_NEWS_NEW_FAILURE",
  }